import { z } from "zod";
import { dateStr, id, localDateTime, nullableText } from "./common";
import { localPoint } from "./schedule";

export const tourStatus = z.enum(["scheduled", "completed", "no_show", "cancelled"]);
export const tourDisposition = z.enum(["hot", "warm", "cold", "not_a_fit"]);
export type TourDisposition = z.infer<typeof tourDisposition>;
export const tourDuration = z.number().int().min(5).max(480);
export const tourOffset = localPoint.shape.offset;

export const tourCreate = z.object({
  leadId: id,
  venueId: id,
  scheduledAt: localDateTime,
  offset: tourOffset,
  durationMin: tourDuration.default(30),
  assignedMemberId: id.nullable().optional(),
  notifyClient: z.boolean().default(false),
  notes: nullableText.optional(),
});
export type TourCreate = z.infer<typeof tourCreate>;

export const tourPatch = z.object({
  scheduledAt: localDateTime.optional(),
  offset: tourOffset,
  durationMin: tourDuration.optional(),
  assignedMemberId: id.nullable().optional(),
  notes: nullableText.optional(),
});
export type TourPatch = z.infer<typeof tourPatch>;

export const tourComplete = z.object({ disposition: tourDisposition, notes: nullableText.optional() });
export type TourComplete = z.infer<typeof tourComplete>;
export const tourNote = z.object({ notes: nullableText.optional() });

export const tourListQuery = z
  .object({ from: dateStr, to: dateStr, venueId: id.optional(), leadId: id.optional() })
  .refine((r) => r.from <= r.to, { message: "from must be ≤ to", path: ["to"] });
export type TourListQuery = z.infer<typeof tourListQuery>;
